import PolicyLayout, { H2, P, UL } from "./PolicyLayout";

export default function PrivacyPolicy() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      testid="page-privacy-policy"
      canonical="/privacy-policy"
      seoTitle="Privacy Policy | Sri Durga Foods"
      seoDescription="How Sri Durga Foods collects, uses and protects your personal data — cookies, orders, payments and account information."
    >
      <P>
        Sri Durga Foods (&ldquo;we&rdquo;, &ldquo;our&rdquo;, &ldquo;us&rdquo;) respects your privacy and is
        committed to protecting the personal information you share with us
        when using <strong>www.sridurgafoods.com</strong>. This Privacy
        Policy explains what data we collect, how we use it, and the rights
        you have over your information.
      </P>

      <H2>1. Information we collect</H2>
      <UL>
        <li><strong>Account & contact details:</strong> name, email address, phone number, and password (stored as a one-way bcrypt hash — never in plain text).</li>
        <li><strong>Delivery information:</strong> shipping addresses including house number, street, landmark, city, state and pincode.</li>
        <li><strong>Order information:</strong> products purchased, variants, quantities, order totals and order history.</li>
        <li><strong>Payment information:</strong> handled entirely by Razorpay. We receive only the transaction ID, status and signature — no card numbers, CVV or UPI PINs are stored on our servers.</li>
        <li><strong>Technical information:</strong> IP address, browser type, device type, anonymised analytics, and cookies used to keep you logged in and remember your cart.</li>
      </UL>

      <H2>2. How we use your information</H2>
      <UL>
        <li>To process and deliver your orders and send transactional updates (order confirmation, dispatch, delivery status).</li>
        <li>To provide customer support and respond to your enquiries.</li>
        <li>To improve our website, product range, and user experience.</li>
        <li>To send promotional communications (only if you have opted in; you may opt out at any time).</li>
        <li>To prevent fraud, abuse, and comply with legal obligations.</li>
      </UL>

      <H2>3. Cookies and analytics</H2>
      <P>
        We use first-party cookies and local storage strictly to keep you
        signed in, remember your cart contents, save your last-used delivery
        pincode, and run basic site analytics. We do not sell your browsing
        data to advertisers. You may disable cookies through your browser
        settings; some site features may not work fully without them.
      </P>

      <H2>4. Data storage and security</H2>
      <P>
        Your personal information is stored on secure servers with
        industry-standard encryption (TLS in transit; hashed passwords at
        rest). We implement administrative, technical and physical
        safeguards to protect your data, though no system can be guaranteed
        100% secure.
      </P>

      <H2>5. Third-party integrations</H2>
      <UL>
        <li><strong>Razorpay</strong> — processes online payments. Razorpay receives the information needed to complete the transaction (name, email, phone, amount, order ID). View their privacy policy at razorpay.com/privacy.</li>
        <li><strong>Shiprocket</strong> — handles shipping. The recipient&apos;s name, address, phone, pincode, parcel weight and order details are shared with Shiprocket and the assigned courier partner. View their policy at shiprocket.in/privacy-policy.</li>
        <li><strong>Google Sign-In (optional)</strong> — if you choose to sign in with Google, we receive your name, email and profile picture from Google.</li>
        <li><strong>WhatsApp notifications</strong> — order updates may be sent via WhatsApp to the phone number you provide.</li>
      </UL>

      <H2>6. Sharing your information</H2>
      <P>
        We never sell, rent or trade your personal information. We share
        data only with the partners listed above strictly for order
        fulfilment, and with law-enforcement agencies if required by a
        valid legal order.
      </P>

      <H2>7. Data retention</H2>
      <P>
        We retain order records as required for tax, accounting and
        consumer-protection laws in India (typically up to 7 years). Account
        information is retained as long as your account is active. You may
        request deletion of your account by writing to us.
      </P>

      <H2>8. Your rights</H2>
      <UL>
        <li>Access the personal data we hold about you.</li>
        <li>Request correction of inaccurate or incomplete data.</li>
        <li>Request deletion of your account and personal data, subject to legal retention obligations.</li>
        <li>Withdraw consent for promotional messages at any time.</li>
        <li>Request a copy of your data in a portable format.</li>
      </UL>
      <P>To exercise any of these rights, please contact us using the details below.</P>

      <H2>9. Children&apos;s privacy</H2>
      <P>
        Our services are not directed to children under 18. We do not
        knowingly collect personal information from anyone under 18 without
        verified parental consent. If you believe a child has provided us
        with personal data, please contact us so we can remove it.
      </P>

      <H2>10. Updates to this policy</H2>
      <P>
        We may revise this Privacy Policy from time to time. The &ldquo;Last
        updated&rdquo; date at the top of this page indicates when it was last
        revised. Continued use of the Website constitutes acceptance of any
        updates.
      </P>
    </PolicyLayout>
  );
}
